export default __webpack_public_path__ + "static/2-7b25e360de263e240f56bcbb170e3967.png";